// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function SwitchViewButton(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  return React.createElement("div", {
              "aria-label": props.ariaLabel,
              className: "Label flex flex-row gap-3 items-end cursor-pointer mt-4",
              "data-testid": Core__Option.getOr(props.dataTestId, ""),
              role: "button",
              style: {
                color: themeObj.colorPrimary,
                float: "left",
                fontSize: "14px",
                fontWeight: themeObj.fontWeightNormal,
                width: "fit-content"
              },
              tabIndex: 0,
              onKeyDown: props.onKeyDown,
              onClick: props.onClick
            }, props.icon, props.title);
}

var make = SwitchViewButton;

export {
  make ,
}
/* react Not a pure module */
